module.exports = __webpack_public_path__ + "img/dedicated-offers.6ee28a93.svg";